// Curriculum structure - i18n keys only, content is in fr.json / en.json
// Each chapter: id, displayed module number, array of chapter keys
export const chapters = [
  {
    id: "ch10",
    num: "01",
    modules: ["ch10_m1", "ch10_m2", "ch10_m3"],
  },
  {
    id: "ch1",
    num: "02",
    modules: ["ch1_m1", "ch1_m2", "ch1_m3"],
  },
  {
    id: "ch2",
    num: "03",
    modules: ["ch2_m1", "ch2_m2", "ch2_m3", "ch2_m4", "ch2_m5", "ch2_m6"],
  },
  {
    id: "ch3",
    num: "04",
    modules: [
      "ch3_m1",
      "ch3_m2",
      "ch3_m3",
      "ch3_m4",
      "ch3_m5",
      "ch3_m6",
      "ch3_m7",
      "ch3_m8",
      "ch3_m9",
      "ch3_m10",
    ],
  },
  {
    id: "ch4",
    num: "05",
    modules: [
      "ch4_m1",
      "ch4_m2",
      "ch4_m3",
      "ch4_m4",
      "ch4_m5",
      "ch4_m6",
      "ch4_m7",
      "ch4_m8",
    ],
  },
  {
    id: "ch5",
    num: "06",
    modules: [
      "ch5_m1",
      "ch5_m2",
      "ch5_m3",
      "ch5_m4",
      "ch5_m5",
      "ch5_m6",
      "ch5_m7",
      "ch5_m8",
    ],
  },
  {
    id: "ch6",
    num: "07",
    modules: ["ch6_m1", "ch6_m2", "ch6_m3", "ch6_m4", "ch6_m5"],
  },
  {
    id: "ch7",
    num: "08",
    modules: ["ch7_m1", "ch7_m2", "ch7_m3"],
  },
  {
    id: "ch8",
    num: "09",
    modules: ["ch8_m1", "ch8_m2", "ch8_m3", "ch8_m4"],
  },
  {
    id: "ch9",
    num: "10",
    modules: ["ch9_m1"],
  },
];
